import React, { createContext, useState, useContext, ReactNode } from 'react';

export interface PreOSData {
  os_number?: string;
  created_at: string;
  customer_name: string;
  customer_contact: string;
  product: {
    description: string;
  };
  manufacturer: {
    name: string;
  };
  salesman: string;
  ophthalmologist: string;
  customer_certified_name: string;
  prevision?: string;
  status: string;
  register_by_name: string;
  esf_right_eye: number;
  cil_right_eye: number;
  eixo_right_eye: number;
  add_right_eye: number;
  dnp_right_eye: number;
  height_right_eye?: number;
  esf_left_eye: number;
  cil_left_eye: number;
  eixo_left_eye: number;
  add_left_eye: number;
  dnp_left_eye: number;
  height_left_eye?: number;
  horizontal: number;
  vertical: number;
  po: number;
  diagonal: number;
  model: string;
  frame: string;
  reference?: string;
  mounting: number;
  antiscratch: number;
  coloring: number;
  coloring_type?: string;
  antireflection: number;
  antireflection_type?: string;
  observations?: string;
  print_prisma: number;
  right_base: number;
  right_base_quantity: number;
  left_base: number;
  left_base_quantity: number;
}

interface PDFContextData {
  // eslint-disable-next-line no-unused-vars
  setPdfData: (data: PreOSData) => void;
  pdfData: PreOSData;
}

const PDFContext = createContext<PDFContextData>({} as PDFContextData);

const PDFProvider = ({ children }: { children: ReactNode }) => {
  const [pdfData, setPdfData] = useState<PreOSData>({} as PreOSData);

  return (
    <PDFContext.Provider value={{ pdfData, setPdfData }}>
      {children}
    </PDFContext.Provider>
  );
};

function usePDFData(): PDFContextData {
  const context = useContext(PDFContext);

  return context;
}

export { PDFProvider, usePDFData };
